module.exports = __webpack_public_path__ + "img/lALPDhmOw39u8LZszQFq_362_108.png_720x720q90g.0b6f503f.jpg";